import AppModal from '@components/AppModal';
import { ActivityComponentType, useFlow } from '@stackflow/react';

declare module '@stackflow/config' {
    interface Register {
        DeleteAllMyMenuModal: {};
    }
}

const DeleteAllMyMenuModal: ActivityComponentType<'DeleteAllMyMenuModal'> = () => {
    const { pop } = useFlow();
    const handleDeleteAllMyMenu = () => {
        pop();
    };
    return (
        <AppModal title={'저장하신 MY메뉴를 모두\n삭제할까요?'}
            deny='취소'
            confirm='삭제'
            onConfirm={handleDeleteAllMyMenu} />
    );
};

export default DeleteAllMyMenuModal;
